<app-alert-bar></app-alert-bar>

<header class="white-header gtmsection-header">
    <div class="container">
        <div class="left-side">
            <div class="logo selenium-header-logo">
                <a
                    [routerLink]="[this.userService.hasStudentExperience() ? '/student' : '/']"
                    title="Homepage"
                >
                    <img [src]="getLogo()" alt="PBS LearningMedia logo" />
                </a>
            </div>
            <div *ngIf="this.userService.hasStudentExperience()" class="for-students-mark">
                FOR STUDENTS
            </div>
            <div
                *ngIf="
                    (this.userService.hasStudentExperience() && localizationLogo) ||
                    !this.userService.hasStudentExperience() ||
                    isHomePage
                "
                [ngStyle]="{
                    'background-color': !isHomePage ? 'rgba(0,0,0,0.3)' : ''
                }"
                class="vertical-bar"
            ></div>
            <div
                *ngIf="
                    (this.userService.hasStudentExperience() && localizationLogo) ||
                    !this.userService.hasStudentExperience() ||
                    isHomePage
                "
                class="localization"
            >
                <app-localization-confirm
                    *ngIf="!this.userService.hasStudentExperience()"
                ></app-localization-confirm>
                <div
                    #localizationDropdown="ngbDropdown"
                    (click)="closeRightHandMenus()"
                    [autoClose]="true"
                    [ngClass]="{
                        'is-student': this.userService.hasStudentExperience() && !isHomePage
                    }"
                    class="dropdown"
                    ngbDropdown
                >
                    <div
                        *ngIf="!localizationLogo && !this.userService.hasStudentExperience()"
                        class="localize-dropdown selenium-localize-dropdown"
                        ngbDropdownToggle
                    >
                        <button class="text selenium-choose-station-button">Choose Station</button>
                    </div>
                    <div
                        *ngIf="localizationLogo && !this.userService.hasStudentExperience()"
                        class="localize-dropdown has-logo"
                        ngbDropdownToggle
                        tabindex="0"
                    >
                        <img
                            [alt]="fullCommonName + ' logo'"
                            [src]="localizationLogo"
                            class="localize-logo"
                        />
                    </div>
                    <div
                        *ngIf="localizationLogo && this.userService.hasStudentExperience()"
                        class="localize-dropdown has-logo"
                        tabindex="0"
                    >
                        <img
                            [alt]="fullCommonName + ' logo'"
                            [src]="localizationLogo"
                            class="localize-logo"
                        />
                    </div>
                    <div ngbDropdownMenu>
                        <div class="close-localization-dropdown-top-wrapper">
                            <button (click)="localizationDropdown.close()">
                                <app-icon [type]="'X'"></app-icon>
                            </button>
                        </div>
                        <app-localization></app-localization>
                        <div class="close-localization-dropdown-bottom-wrapper">
                            <button (click)="localizationDropdown.close()">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-side">
            <!--Desktop Sign In/Sign Up Section-->
            <div class="auth">
                <ng-container *ngIf="!userService.isLoggedIn(); else userLoggedIn">
                    <app-register
                        *ngIf="this.userService.hasStudentExperience()"
                        [isStudent]="this.userService.hasStudentExperience()"
                        [nextURL]="nextUrl"
                    ></app-register>
                    <app-register
                        *ngIf="!this.userService.hasStudentExperience()"
                        [nextURL]="nextUrl"
                    ></app-register>
                </ng-container>
                <ng-template #userLoggedIn>
                    <div class="logged-in selenium-logged-in" ngbDropdown>
                        <div class="auth-dropdown" ngbDropdownToggle>
                            <span>
                                <app-icon [type]="'User'"></app-icon>
                                <span class="name">
                                    {{ getName() }}
                                </span>
                            </span>
                        </div>
                        <div class="selenium-user-loggedin-dropdown" ngbDropdownMenu>
                            <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                                <app-link
                                    [attr.data-gtmlabel]="'Dashboard'"
                                    appRouterLink="/dashboard/"
                                    class="{{ gtmPrefix + 'dashboard' }} selenium-dashboard"
                                    >Dashboard</app-link
                                >
                            </div>
                            <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                                <app-link
                                    [attr.data-gtmlabel]="'Tools'"
                                    appRouterLink="/tools/lessonbuilder/"
                                    class="{{ gtmPrefix + 'tools' }} selenium-lesson-builder"
                                    >Lesson Builder</app-link
                                >
                            </div>

                            <div class="item">
                                <app-link
                                    [appRouterLink]="
                                        !this.userService.hasStudentExperience()
                                            ? '/tools/rosters/assignments/'
                                            : '/student/assignments'
                                    "
                                    [attr.data-gtmlabel]="'Assignments'"
                                    class="{{ gtmPrefix + 'assignments' }} selenium-assignments"
                                    >Assignments</app-link
                                >
                            </div>

                            <div class="item">
                                <app-link
                                    [appRouterLink]="
                                        !this.userService.hasStudentExperience()
                                            ? '/tools/rosters/'
                                            : '/student/classes/'
                                    "
                                    [attr.data-gtmlabel]="'Classes'"
                                    class="{{ gtmPrefix + 'rosters' }} selenium-classes"
                                    >Classes</app-link
                                >
                            </div>

                            <div class="item">
                                <app-link
                                    [attr.data-gtmlabel]="'Favorites'"
                                    appRouterLink="/favorites/"
                                    class="{{ gtmPrefix + 'favorites' }} selenium-favorites"
                                    >Favorites</app-link
                                >
                            </div>

                            <div class="item">
                                <app-link
                                    [attr.data-gtmlabel]="'Folders'"
                                    appRouterLink="/folders/"
                                    class="{{ gtmPrefix + 'folders' }} selenium-folders"
                                    >Folders</app-link
                                >
                            </div>
                            <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                                <app-link
                                    [attr.data-gtmlabel]="'Profile'"
                                    appRouterLink="/profile/"
                                    class="{{ gtmPrefix + 'profile' }} selenium-profile"
                                    >Profile</app-link
                                >
                            </div>

                            <div class="item">
                                <a
                                    [attr.data-gtmlabel]="'Logout'"
                                    [href]="userService.getLogoutUrl()"
                                    class="{{ gtmPrefix + 'logout selenium-logout' }}"
                                    >Sign Out
                                </a>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>

            <!--Search Section-->
            <div class="search">
                <app-external-search-input
                    [placeholder]="'Search'"
                    [type]="'for-header'"
                ></app-external-search-input>
            </div>

            <!--Mobile Profile and Search Burger-->
            <div class="burger-menu-icon">
                <app-icon
                    (click)="toggleMenu('burger-menu')"
                    *ngIf="!showBurgerMenu"
                    [type]="'Menu'"
                    class="menu-icon"
                ></app-icon>
                <app-icon
                    (click)="toggleMenu('burger-menu')"
                    *ngIf="showBurgerMenu"
                    [type]="'X'"
                ></app-icon>
            </div>
            <div class="auth-menu-icon">
                <app-icon
                    (click)="toggleMenu('user-menu')"
                    *ngIf="!showUserMenu"
                    [type]="'User'"
                ></app-icon>
                <app-icon
                    (click)="toggleMenu('user-menu')"
                    *ngIf="showUserMenu"
                    [type]="'X'"
                ></app-icon>
            </div>
        </div>
    </div>

    <div class="mobile-menu">
        <div *ngIf="this.userService.hasStudentExperience()" class="for-students-bar">
            FOR STUDENTS
        </div>

        <!--Auth User Menu-->
        <div *ngIf="showUserMenu && userService.isLoggedIn()" class="user-menu container">
            <div *ngIf="this.userService.hasStudentExperience()" class="pt-5">
                <app-code-input></app-code-input>
            </div>

            <div *ngIf="this.userService.hasStudentExperience()" class="item nav-menu-search">
                <app-external-search-input
                    [placeholder]="'Search'"
                    [type]="'for-header'"
                ></app-external-search-input>
            </div>

            <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                <app-link
                    [attr.data-gtmlabel]="'Dashboard'"
                    appRouterLink="/dashboard/"
                    class="{{ gtmPrefix + 'dashboard' }}"
                    >Dashboard</app-link
                >
            </div>
            <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                <app-link
                    [attr.data-gtmlabel]="'Tools'"
                    appRouterLink="/tools/lessonbuilder/"
                    class="{{ gtmPrefix + 'tools' }}"
                    >Lesson Builder</app-link
                >
            </div>

            <div
                [ngClass]="{ 'student-item': this.userService.hasStudentExperience() }"
                class="item"
            >
                <app-link
                    [appRouterLink]="
                        !this.userService.hasStudentExperience()
                            ? '/tools/rosters/assignments/'
                            : '/student/assignments'
                    "
                    [attr.data-gtmlabel]="'Assignments'"
                    [badgeCount]="assignmentsNotStarted"
                    class="gtm-header-dropdown-assignments"
                    >Assignments
                </app-link>
            </div>

            <div
                [ngClass]="{ 'student-item': this.userService.hasStudentExperience() }"
                class="item"
            >
                <app-link
                    [appRouterLink]="
                        !this.userService.hasStudentExperience()
                            ? '/tools/rosters/'
                            : '/student/classes/'
                    "
                    [attr.data-gtmlabel]="'Classes'"
                    class="gtm-header-dropdown-rosters"
                    >Classes</app-link
                >
            </div>
            <div
                [ngClass]="{ 'student-item': this.userService.hasStudentExperience() }"
                class="item"
            >
                <app-link
                    [attr.data-gtmlabel]="'Favorites'"
                    appRouterLink="/favorites/"
                    class="gtm-header-dropdown-favorites"
                    >Favorites</app-link
                >
            </div>

            <div
                [ngClass]="{ 'student-item': this.userService.hasStudentExperience() }"
                class="item"
            >
                <app-link
                    [attr.data-gtmlabel]="'Folders'"
                    appRouterLink="/folders/"
                    class="gtm-header-dropdown-folders"
                    >Folders</app-link
                >
            </div>
            <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                <app-link
                    [attr.data-gtmlabel]="'Profile'"
                    appRouterLink="/profile/"
                    class="gtm-header-dropdown-profile"
                    >Profile</app-link
                >
            </div>

            <div *ngIf="!this.userService.hasStudentExperience()" class="item">
                <a
                    [attr.data-gtmlabel]="'Logout'"
                    [href]="userService.getLogoutUrl()"
                    class="gtm-header-dropdown-logout"
                    >Sign out</a
                >
            </div>

            <a
                *ngIf="this.userService.hasStudentExperience()"
                [href]="userService.getLogoutUrl()"
                class="student-sign-out-btn mt-7"
            >
                Sign out
            </a>
        </div>

        <!--Burger Search Menu-->
        <div *ngIf="showBurgerMenu" class="nav-menu container">
            <div *ngIf="this.userService.hasStudentExperience()" class="mb-4">
                <app-code-input></app-code-input>
            </div>

            <div class="item nav-menu-search">
                <app-external-search-input
                    [placeholder]="'Search'"
                    [type]="'for-header'"
                ></app-external-search-input>
            </div>

            <div class="item">
                <app-browse-by></app-browse-by>
            </div>

            <ng-container *ngIf="!userService.isLoggedIn()">
                <div class="student-register">
                    <p *ngIf="this.userService.hasStudentExperience()" class="text-center my-6">
                        Access your Assignments, Classes, and Favorites by signing in.
                    </p>
                    <!--Student Sign In/Sign Up-->
                    <app-register
                        *ngIf="this.userService.hasStudentExperience()"
                        [isStudent]="this.userService.hasStudentExperience()"
                        [nextURL]="nextUrl"
                    ></app-register>

                    <!--Teacher Sign In/Sign Up-->
                    <app-register
                        *ngIf="!this.userService.hasStudentExperience()"
                        [nextURL]="nextUrl"
                    ></app-register>
                </div>
            </ng-container>
        </div>
    </div>
</header>

<!--Teacher and student desktop menus-->
<ng-container
    *ngIf="!this.userService.hasStudentExperience(); then teacherMenu; else studentMenu"
></ng-container>
<ng-template #teacherMenu>
    <app-main-navigation></app-main-navigation>
</ng-template>
<ng-template #studentMenu>
    <div class="for-students-bar">FOR STUDENTS</div>
    <div class="student-menu-container gtmsection-student-menu-header">
        <app-student-menu [badgeCount]="assignmentsNotStarted"></app-student-menu>
    </div>
</ng-template>
